<template>
  <div class="examineinfo">
    <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="在线验货"
          @click-left="closePage"
      >
      </z-nav-bar>
    </z-fix-top>
    <Stance
      v-if="code != '0' && !loading"
      type="general"
      :btn-text="btnText"
      :show-info="false"
      :descText="msg"
      @click="btnClick"
      :show-btn="code == '-5' && !loading"
    />

    <z-pop-up @closed="closePopup" class="popup" v-model="showPopUp" position="bottom">
      <section class="chooseitem" v-show="!changeDesc">
        <div v-clickeffect @click="judgeInputOrJump" >商品已通过其他途径卖出</div>
        <div v-clickeffect @click="() => changeToTextArea('2')">
        商品暂时不在身边，无法验货</div>
        <div></div>
        <div v-clickeffect @click="closeModal">取消</div>
      </section>
      <section class="textarea" v-show="changeDesc">
        <div class="title">
          <span @click="closeModal">取消</span>
          <span>填写事件描述</span>
          <span @click="unableCheck">提交</span>
        </div>
        <z-field
            ref="unabletextarea"
            v-model="unabledesc"
            type="textarea"
            placeholder="请描述您遇到的问题，平台收到后会尽快处理"
            rows="3"
            autosize
            :maxlength="100"
            count-word
          />
      </section>
    </z-pop-up>

      <div v-if="code == '0'" class="form">
        <section class="product-info">
          <div class="title">
            <span>需验货的商品信息</span>
            <div v-if="unableInpspect" class="bluetips" @click="() => {this.showPopUp = true}">
              <!-- <img src="./images/icon.png" alt=""> -->
              <span>商品不在身边怎么办?</span>
            </div>
          </div>
          <div class="info">
            <z-image
              fit="cover"
              :set-pic-size="500"
              :src="info.headImage">
            </z-image>
            <div>
               <span>{{ info.title }}</span>
              <span><span>¥&nbsp;</span> {{ Number(info.price)/100 || '-' }}</span>
            </div>
          </div>
        </section>
        <section class="upload-area" v-if="info.source != '3'">
          <div class="title">请上传个人及商品信息</div>
          <div class="detail">{{ uploadTitle }}</div>
          <div class="area">
            <div class="title">
              <span>1</span>
              <span>拍摄上传本人（{{info.name}}）与验证商品的合照</span>
            </div>
            <div class="detail">请确保人脸无遮挡，拍摄商品需与验货的商品一致且要展示商品全貌</div>
            <div class="upload">
              <div class="sample-cover" :style="{backgroundImage: `url(${imgs[1]})`}"></div>
              <media-upload-item
                order="1"
                @uploaded="Uploaded">
                <div class="add"></div>
                <span>点击拍摄</span>
              </media-upload-item>
            </div>
            <div class="uploadbottom">
              <span>示例</span>
              <span>拍摄合照</span>
            </div>
          </div>
          <div class="area">
            <div class="title">
              <span>2</span>
              <span>拍摄上传验证商品正反面照片</span>
            </div>
            <div class="detail">请确保拍摄商品与需要验货的商品一致且需展示商品全貌</div>
            <div class="upload">
              <div class="sample-cover" :style="{backgroundImage: `url(${imgs[0]})`}"></div>
              <media-upload-item
                order="2"
                @uploaded="Uploaded">
                <div class="add"></div>
                <span>点击拍摄</span>
              </media-upload-item>
            </div>
            <div class="uploadbottom">
              <span>示例</span>
              <span>拍摄正面照片</span>
            </div>

            <div class="upload upload2">
              <div class="sample-cover" :style="{backgroundImage: `url(${imgs[2]})`}"></div>
              <media-upload-item
                order="3"
                @uploaded="Uploaded">
                <div class="add"></div>
                <span>点击拍摄</span>
              </media-upload-item>
            </div>
            <div class="uploadbottom">
              <span>示例</span>
              <span>拍摄反面照片</span>
            </div>
          </div>
        </section>
        <section class="basic-info" v-if="info.source == '3'">
          <div class="title">请上传此商品订单下的有效单号</div>
          <div class="detail">{{ uploadTitle }}</div>
          <div class="item">
            <z-field
              ref="input"
              type="text"
              @focus="intoInputView"
              v-model="cardId"
              placeholder="请输入快递单号"
            />
          </div>
        </section>
        <!-- 上传凭证 -->
        <section class="basic-info" v-if="info.source == '3'">
          <div class="title">上传凭证</div>
          <div class="detail">{{ uploadphoto }}</div>
          <div class="photo">
            <z-upload
              v-model="pics"
              ref="upload"
              weixin
              :process-file="processFile"
              accept="image/*"
              :max="6"
            />
          </div>
        </section>
        <section class="description">
          <div class="title">事件描述（选填）</div>
          <div class="item">
            <z-field
              v-model="desc"
              type="textarea"
              placeholder="请描述您遇到的问题，可帮助平台准确处理"
              rows="3"
              autosize
              :maxlength="500"
              count-word
            />
          </div>
        </section>
      </div>
      <z-button-group keep-position class="bottom-button">
        <z-button v-if="code != '0' && showBtn" size="small-detail" type="primary" @click="quit">{{ btnTxt }}</z-button>
        <z-button v-if="code == '0' && showBtn" size="small-detail" :disabled="!canSubmit" type="primary" @click="nextTip">提交审核</z-button>
      </z-button-group>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import compress from '@zz-common/zz-ui/lib/utils/image'
import { Stance, Image, Upload, NavBar, Field, FixTop, Button, ButtonGroup, Popup, Dialog } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import { env } from '@zz-common/zz-utils'
import {
  getcertificationstatus,
  getcloudcheckproduct,
  submitcloudcheck
} from '@api/resourceApi'
import {
  queryParams,
  getCookie,
  getDownAppUrl,
  compareVersion,
  isZhuanzhuan,
  tranPics
} from '../../lib/utils'

import MediaUploadItem from './MediaUploadItem/MediaUploadItem'
const query = queryParams()

export default {
  name: 'examineInfo',
  data() {
    return {
      native,
      infoId: query.infoId || this.$route.query.infoId,
      pid: query.pid || this.$route.query.pid,
      source: query.source || this.$route.query.source,
      insert: query.insert || this.$route.query.insert,
      loading: false,
      uploadTitle: '*您提供的信息仅用于信息核查，转转保证您的信息安全不被泄露',
      uploadphoto:
          '您可以提供当前快递单号的物流截图信息，帮助小熊更好的判断（选填，最多支持6张）',
      cardId: '',
      btnTxt: '确定',
      btnText: '进行实人认证',
      btnLink: '',
      desc: '',
      evidence: ['', '', ''],
      oneSubmit: true,
      pics: [],
      // action: { target: 'https://upload.58cdn.com.cn/json?rand=0.1928', zz: true },
      down: false, //需要重新下载最新APP
      showBtn: true, //展示图片
      info: {
        businessId: '',
        source: '',
        infoId: '',
        headImage: '',
        content: '',
        title: '',
        name: '',
        id: '',
        price: ''
      },
      code: '0',
      msg: '好像出了点小问题',
      imgs: [require('./images/frontgoods.jpg'), require('./images/heldgoods.jpg'), require('./images/goodsback.jpg')],
      showPopUp: false,
      changeDesc: false, //切换商品不在身边的原因,
      unabledesc: '',
      checkType: '2',
      inputSource: ['2', '7', '8']
    }
  },
  components: {
    MediaUploadItem,
    Stance,
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-button-group': ButtonGroup,
    'z-image': Image,
    'z-field': Field,
    'z-pop-up': Popup,
    zUpload: Upload
  },
  computed: {
    isOpenHarmony() { // 是否为鸿蒙且版本号小于10.30.10
      return env.$isOpenHarmony && !compareVersion(getCookie('v') || '', '10.30.10')
    },
    pthotoSubmit() {
      return this.evidence.every((item) => item !== '')
    },
    cardIdSubmit() {
      return /^[A-Za-z0-9]{6,}$/.test(this.cardId)
    },
    canSubmit() {
      return this.cardIdSubmit || this.pthotoSubmit
    },
    unableInpspect() {
      return this.info.source !== '3' && this.info.source !== '4' && this.info.source !== '10'
    }
  },
  methods: {
    closePage() {
      native.close()
    },
    closePopup() {
      this.changeDesc = false
    },
    processFile(file, next) {
      compress(
        file,
        {
          compress: true // 开启图片压缩，提高上传的速度，同时修正图片方向修正的问题
        },
        next
      )
    },
    $setPicSize(url) {
      return setPicSize(url, 144, 144)
    },
    init() {
      if (this.isOpenHarmony) {
        this.msg = '当前版本不支持验货，请升级转转APP到最新版本后重试';
        this.code = -1;
        return ''
      }
      console.log('getCookie(v)', getCookie('v'))
      console.log('isZhuanzhuan', isZhuanzhuan)
      console.log('compareVersion', compareVersion('9.14.0', '8.6.0'))
      const appV = native.client
      if (appV === 'zz') {
        if (!compareVersion(getCookie('v') || '', '9.14.0')) {
          this.btnTxt = '下载最新版本'
          this.msg = '请升级最新APP版本后进行云验货'
          this.down = true //下方按钮功能不是关闭页面而是下载app
          this.code = '-1'
          return ''
        }
        return this.getcloudcheckproduct()
      }
      if (appV === 'zzseller') {
        return this.getcloudcheckproduct()
      }
      this.code = '-1'
      this.msg = '请打开APP后进行云验货'
      this.showBtn = false
    },
    btnClick() {
      this.getcertificationstatus()
    },
    quit() {
      if (this.down) {
        const url = getDownAppUrl()
        if (!url) return this.$toast('当前设备不支持下载')
        window.location.href = url
        return ''
      }
      // eslint-disable-next-line eqeqeq
      if (this.code == '-5') {
        this.init()
        return ''
      }
      native.close()
    },
    getcertificationstatus() {
      return getcertificationstatus({})
        .then((respData) => {
          // if (respData) return this.$Toast.success('您已成功完成实人认证');
          if (Number(respData)) {
            return this.$toast('您已完成实人认证，点击页面下方按钮进入下一步')
          }
          return native.skipToUrl({
            targetUrl: this.btnLink,
            needClose: '0'
          })
        })
        .catch((err) => {
          console.error(err)
          if (!err.errMsg) return
          this.$toast(err.errMsg)
        })
    },
    gotoResult() {
      native.skipToUrl({
        targetUrl: `https://feentry.zhuanzhuan.com/spam_cloudInspection?clientid=CloudInspectionPushResult&infoId=${this.info.infoId}`,
        needClose: '1'
      })
    },
    getcloudcheckproduct() {
      this.loading = true
      const params = {}
      if (this.infoId) params.infoId = this.infoId
      if (this.pid) params.pid = this.pid
      if (this.source) params.source = this.source
      if (this.insert) params.insert = this.insert
      return getcloudcheckproduct({ ...params })
        .then((respData) => {
          this.loading = false
          const { code = '', msg = '', data = {}, btnTxt = '', btnLink = '' } = respData
          this.btnTxt = code !== '-5' ? btnTxt || this.btnTxt : '已完成实人认证'
          this.btnLink = btnLink || this.btnLink
          this.msg = msg
          this.info = { ...data }
          if (code === '-5') {
            this.btnText = btnTxt
            this.code = code
          } else if (code === '-3') this.gotoResult()
          //-7账号封禁
          else if (code === '-7' && this.source != '11') {
            Dialog.confirm({
              title: '系统提示',
              message: '因违反转转平台规则，您的账号已被封禁，请先进行账号申诉再在线验货',
              closeOnClickOverlay: false,
              confirmButtonText: '去申诉',
              cancelButtonText: '取消'
            }).then(() => {
              native.skipToUrl({
                targetUrl: 'https://feentry.zhuanzhuan.com/spam_userAppeal?clientid=userRejectReason',
                needClose: '1'
              })
            }).catch(_type => {
              native.close()
            });
            return
          } else if (code == '-8') {
            this.submitSuccess()
            return
          } else if (code === '-7' && this.source == '11') {
            this.code = '0'
          } else {
            this.code = code
          }
          lego.send({
            pagetype: 'ZZUP_CLOUDINSPECTION',
            actiontype: 'PAGE_SHOW_SUCCCESS',
            backup: {
              source: this.info.source,
              infoId: this.infoId
            }
          })
          return respData
        })
        .catch((err) => {
          lego.send({
            pagetype: 'ZZUP_CLOUDINSPECTION',
            actiontype: 'PAGE_SHOW_FAIL',
            backup: {
              source: this.info.source,
              infoId: this.infoId
            }
          })
          if (!err.errMsg) return
          this.$toast(err.errMsg)
        })
    },
    nextTip() {
      if (this.info.source !== '3' && !this.pthotoSubmit) {
        return this.$toast('请拍摄照片后再提交')
      }
      if (this.info.source === '3' && !this.cardIdSubmit) {
        return this.$toast('填写正确的物流单号')
      }
      if (!this.canSubmit) return ''
      if (!this.oneSubmit) return ''
      this.oneSubmit = false
      this.submit()
    },
    Uploaded(rst, _startTime, order) {
      this.evidence.splice(order - 1, 1, rst)
      this.evidence.map((item) => console.log('img', item))
    },
    intoInputView() {
      console.log('input focous----')
      console.log('this.$refs.input----', this.$refs.input)
      setTimeout(() => {
        this.$refs.input.scrollIntoView()
      }, 300)
    },
    submit() {
      const params = {
        id: this.info.id,
        checkType: '0',
        infoId: this.info.infoId,
        reason: this.desc,
        evidence: tranPics(this.pics).join('|')
      }
      if (this.info.source !== '3') params.evidence = this.evidence.join('|')
      if (this.info.source === '3') params.express_num = this.cardId
      lego.send({
        pagetype: 'ZZUP_CLOUDINSPECTION',
        actiontype: 'CLICK',
        backup: {
          source: this.info.source,
          uid: getCookie('uid'),
          ...params
        }
      })
      submitcloudcheck(params)
        .then((res) => {
          lego.send({
            pagetype: 'ZZUP_CLOUDINSPECTION',
            actiontype: 'SUBMIT_SUCCESS',
            backup: {
              uid: getCookie('uid')
            }
          })
          const { code = '', msg = '' } = res
          if (code !== '0') {
            this.oneSubmit = true //等接口返回数据后可以再次提交
            return this.$toast(msg)
          }
          this.submitSuccess()
        })
        .catch((err) => {
          //  失败
          lego.send({
            pagetype: 'ZZUP_CLOUDINSPECTION',
            actiontype: 'SUBMIT_FAIL',
            backup: {
              uid: getCookie('uid'),
              err
            }
          })
          this.oneSubmit = true //等接口返回数据后可以再次提交
          this.$toast(err.message || err || '提交失败')
          console.error(err)
        })
    },
    unableCheck() {
      if (!this.unabledesc) {
        return this.$toast('请填写原因')
      }
      const params = {
        id: this.info.id,
        infoId: this.info.infoId,
        reason: this.unabledesc
      }
      submitcloudcheck({ ...params, checkType: this.checkType }).then((res) => {
        const { code = '', msg = '' } = res
        if (code !== '0') return this.$toast(msg)
        Dialog({
          title: '提交成功',
          message: msg,
          closeOnClickOverlay: false
        }).then(() => {
          native.close()
        });
      })
        .catch((err) => {
          this.$toast(err.message || err || '提交失败')
          console.error(err)
        })
    },
    closeModal() {
      this.showPopUp = false
    },
    goToRadio() {
      const queries = {
        id: this.info.id,
        infoId: this.info.infoId,
        name: this.info.name
      }
      this.$router.replace({
        path: 'UnableInspect',
        query: queries
      })
    },
    changeToTextArea(val) {
      this.checkType = val;
      this.changeDesc = true
      this.$refs.unabletextarea.focus()
    },
    judgeInputOrJump() {
      this.inputSource.includes(this.info.source) ? this.changeToTextArea('1') : this.goToRadio()
    },
    submitSuccess() {
      Dialog({
        title: '提交成功',
        message: '您的在线验货信息已提交成功，系统将在24小时内反馈审核结果，请耐心等待',
        closeOnClickOverlay: false
      }).then(() => {
        native.close()
      });
    }
  },
  mounted() {
    this.init()
    console.log('-------this.from', this.from)
    native.wrap('setKeyboardFrameChangeCallback')((res) => {
      if (!res.kbState) return
      if (res.kbState === '1') {
        console.log('-------输入键盘出现')
      } else {
        console.log('-------输入键盘消失')
        if (this.$refs.input) this.$refs.input.blur()
      }
    })
  }
}
</script>

<style lang="less" scoped>
  @import 'examineInfo.less';
</style>
